function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("defs", null);

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "Payments-Flow",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Payments---transactions",
  transform: "translate(-1251.000000, -141.000000)",
  fill: "#637280",
  fillRule: "nonzero"
}, React.createElement("g", {
  id: "Group-8",
  transform: "translate(1231.000000, 69.000000)"
}, React.createElement("g", {
  id: "Group-11"
}, React.createElement("path", {
  d: "M33.5,72 L21.5,72 C20.6675,72 20.0075,72.6675 20.0075,73.5 L20,82.5 C20,83.3325 20.6675,84 21.5,84 L33.5,84 C34.3325,84 35,83.3325 35,82.5 L35,73.5 C35,72.6675 34.3325,72 33.5,72 Z M33.5,82.5 L21.5,82.5 L21.5,78 L33.5,78 L33.5,82.5 Z M33.5,75 L21.5,75 L21.5,73.5 L33.5,73.5 L33.5,75 Z",
  id: "Shape"
})))));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: "15px",
    height: "12px",
    viewBox: "0 0 15 12",
    version: 1.1,
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/payments.15364188.svg";
export { SvgComponent as ReactComponent };